import { BaseBus } from "./BaseBus";

export class EquipmentData extends BaseBus{

      constructor(busObj: EquipmentData = null) {
            super(busObj);
    
        }
        CID(): any {
            return this.refrigerantEquipmentsId;
        }
        
      refrigerantEquipmentsId: string;
      description: string;
      material: number;
      labor: number;
      refrigerant: number;
      insertDt: Date;
      insertUserId: string;
      updateDt: Date;
      updateUserId: any;
      isActive: boolean;
      sortOrder: number;
      quantity: number;
}